import { AccordionPanel } from "features/WorklistTools/shared/components/AccordionPanel";
import { LabwareTypeInfo } from "features/WorklistTools/shared/interfaces";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import { DestinationWellMapping } from "./DestinationWellMapping/DestinationWellMapping";
import { HarvestWellsMapping } from "./HarvestWellMapping/HarvestWellMapping";
import { MethodSettings } from "./MethodSettings/MethodSettings";

interface ExternalThawToolSidebarProps {
  deadPlateInfo: LabwareTypeInfo[] | undefined;
}

const StyledSidebarContainer = styled.div`
  padding: 20px;
  height: 100%;
  overflow: auto;
  width: 100%;
  resize: horizontal;
`;

export const ExternalThawSidebar = ({
  deadPlateInfo,
}: ExternalThawToolSidebarProps) => {
  return (
    <StyledSidebarContainer>
      <AccordionPanel
        id="method-settings-panel"
        panel="method-settings"
        title="Method Settings"
      >
        <MethodSettings deadPlateTypeInfo={deadPlateInfo} />
      </AccordionPanel>

      <AccordionPanel
        id="harvest-wells-mapping-panel"
        panel="harvest-wells"
        title="Harvest Wells"
      >
        <HarvestWellsMapping />
      </AccordionPanel>

      <AccordionPanel
        id="destination-well-mapping-panel"
        panel="destination-well-mapping"
        title="Destination Well Mapping"
      >
        <DestinationWellMapping />
      </AccordionPanel>
    </StyledSidebarContainer>
  );
};
